<div class="dataList">
    <div class="records">
        <div class="filters">

            <button mat-raised-button class="Save" (click)="openRequestFilterSidePanel()" [disabled]="update"><i
                class="flaticon-filter"></i>
                Filter</button>
            <button mat-icon-button [matTooltip]="'Clear All Filters'" matTooltipPosition="right"
                *ngIf="myOrderService.filtersAdded" class="clearFilter" (click)="clearFilters()"><i
                class="flaticon-undo-arrow"></i></button>
        </div>
        <mat-button-toggle-group [ngModel]="myOrderService.listQPModel.request_type"
            (ngModelChange)="filterByRequestType($event)" name="request_type" [disabled]="update">
            <mat-button-toggle value="">All</mat-button-toggle>
            <mat-button-toggle value="one_way">One way</mat-button-toggle>
            <mat-button-toggle value="buy_sell">Trade</mat-button-toggle>
            <mat-button-toggle value="lease">Lease</mat-button-toggle>
            <mat-button-toggle value="empty_repo">Empty Repo</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <logzy-table-loader *ngIf="loading"></logzy-table-loader>
    <div class="setTable" *ngIf="!loading">

        <ng-container *ngIf="requestList?.data?.length">
            <mat-table [dataSource]="requestList" matSort (matSortChange)="announceSortChange($event)">

                <!--- Note that these columns can be defined in any order.
                The actual rendered columns are set as a property on the row definition" -->

                <ng-container [matColumnDef]="'transaction_type_display'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Nature</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 " (click)="view(data)">
                        <span class="mobile-label natureMl">Nature:</span>
                        <span class="natureChip">
                            <!-- [class]="data?.transaction_type ? data?.transaction_type : 'use'" -->
                            {{myOrderService.getNatureOfRequest(data)}}
                        </span>
                    </mat-cell>
                </ng-container>

                <ng-container [matColumnDef]="'request_number'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Request No</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12  fw-bold reqNocell" (click)="view(data)"
                        (mouseenter)="showCommercials(data)" (mouseleave)="cancelSubscription()"
                        [ngClass]="loadCommercials ? 'changePointer': ''">
                        <span class="mobile-label ">Request No:</span>
                        {{data?.request_number == null ? "-" : data?.request_number}}
                        <span class="new-request-bubble" *ngIf="!data?.is_read"></span>
                        <div id="{{data?.request_number}}" *ngIf="requestNo == data.request_number">
                            <div class="commercialDetails" *ngIf="latestQuotes!=null">
                                <span *ngFor="let quote of latestQuotes?.quote_items">
                                    <div *ngIf="data.request_type.dev_name == 'one_way'">
                                        <div>
                                            <span fxFlex="100">Pick-up charge/cont: <ng-container
                                                *ngIf="quote?.pickup_charge != null">
                                                    {{quote?.pickup_charge + ' ' + quote?.pickup_charge_currency}}
                                                </ng-container>
                                                <ng-container *ngIf="quote?.pickup_charge == null">-</ng-container>
                                                <ng-container *ngIf="data.transaction_type == 'use'">
                                                    ({{latestQuotes?.payee == 'customer' ? 'USER' : 'ARCON'}} Pays)
                                                </ng-container>
                                                <ng-container *ngIf="data.transaction_type == 'supply'">
                                                    ({{latestQuotes?.payee == 'supplier' ? 'SUPPLIER' : 'ARCON'}} Pays)
                                                </ng-container>
                                            </span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Free Days: <ng-container
                                                *ngIf="quote?.min_free_days != null">
                                                    {{quote?.min_free_days}}
                                                </ng-container>
                                                <ng-container *ngIf="quote?.min_free_days == null">-</ng-container>
                                            </span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Per Diem charge/cont: <ng-container
                                                *ngIf="quote?.min_per_diem != null">
                                                    {{quote?.min_per_diem + ' ' + quote?.min_per_diem_currency}}
                                                </ng-container>
                                                <ng-container *ngIf="quote?.min_per_diem == null">-</ng-container>
                                            </span>
                                        </div>
                                    </div>

                                    <div *ngIf="data.request_type.dev_name == 'buy_sell'">
                                        <div>
                                            <span fxFlex="100" *ngIf="data.transaction_type == 'use'">Buy-price:
                                                <ng-container *ngIf="quote?.price != null">
                                                    {{quote?.price + ' ' + quote?.price_currency}}
                                                </ng-container>
                                                <ng-container *ngIf="quote?.price == null">-</ng-container>
                                            </span>
                                            <span fxFlex="100" *ngIf="data.transaction_type == 'supply'">Sell-price:
                                                <ng-container *ngIf="quote?.price != null">
                                                    {{quote?.price + ' ' + quote?.price_currency}}
                                                </ng-container>
                                                <ng-container *ngIf="quote?.price == null">-</ng-container>
                                            </span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Container Condition:
                                                {{quote?.container_condition.value}}
                                            </span>
                                        </div>
                                    </div>
                                    <div *ngIf="data.request_type.dev_name == 'lease'">
                                        <div>
                                            <span fxFlex="100">Container Size:
                                                {{quote?.container_size_type.display}}</span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Container Condition:
                                                {{quote?.container_condition.value}}</span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Leasing Period: {{quote?.leasing_period_days}}
                                                Days</span>
                                        </div>
                                    </div>
                                </span>
                            </div>
                            <div class="commercialDetails" *ngIf="latestQuotes==null">
                                <span>
                                    <div *ngIf="data.request_type.dev_name == 'one_way'">
                                        <div>
                                            <span fxFlex="100">Pick-up charge/cont:
                                                -
                                            </span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Free Days: -
                                            </span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Per Diem charge/cont: -
                                            </span>
                                        </div>
                                    </div>

                                    <div *ngIf="data.request_type.dev_name == 'buy_sell'">
                                        <div>
                                            <span fxFlex="100" *ngIf="data.transaction_type == 'use'">Buy-price:
                                                -
                                            </span>
                                            <span fxFlex="100" *ngIf="data.transaction_type == 'supply'">Sell-price:
                                                -
                                            </span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Container Condition:
                                                - </span>
                                        </div>
                                    </div>
                                    <div *ngIf="data.request_type.dev_name == 'lease'">
                                        <div>
                                            <span fxFlex="100">Container Size:
                                                -</span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Container Condition:
                                                -</span>
                                        </div>
                                        <div>
                                            <span fxFlex="100">Leasing Period: -
                                            </span>
                                        </div>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </mat-cell>
                </ng-container>

                <ng-container [matColumnDef]="'pols'">
                    <mat-header-cell *matHeaderCellDef> Pick-up</mat-header-cell>
                    <mat-cell *matCellDef="let data; let i=index" class=" fs-12 user_name">
                        <ng-container
                            *ngIf="data?.status.dev_name == 'received' || data?.status.dev_name == 'accepted_by_internal_user' || data?.status.dev_name == 'transferred_by_internal_user'">
                            <span class="mobile-label">Pick-up:</span>
                            <span class="fs-12 " *ngIf="data?.pols?.length">
                                {{data?.pols[0].name_display}}
                                <ng-container *ngIf="data?.pols?.length > 1">
                                    <span [matTooltip]="data?.pols | tooltipList " matTooltipClass="tooltip-list">
                                        + {{data?.pols?.length - 1}} more
                                    </span>
                                </ng-container>
                            </span>
                            <span class="fs-12 " *ngIf="data?.pols?.length == 0">
                                -
                            </span>
                        </ng-container>
                        <ng-container
                            *ngIf="!(data?.status.dev_name == 'received' || data?.status.dev_name == 'accepted_by_internal_user' || data?.status.dev_name == 'transferred_by_internal_user')">
                            <span class="mobile-label">Pick-up:</span>
                            <span class="fs-12 " *ngIf="data?.req_pols?.length">
                                {{data?.req_pols[0].name_display}}
                                <ng-container *ngIf="data?.req_pols?.length > 1">
                                    <span [matTooltip]="data?.req_pols | tooltipList " matTooltipClass="tooltip-list">
                                        + {{data?.req_pols?.length - 1}} more
                                    </span>
                                </ng-container>
                            </span>
                            <span class="fs-12 " *ngIf="data?.req_pols?.length == 0">
                                -
                            </span>
                        </ng-container>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'pods'">
                    <mat-header-cell *matHeaderCellDef> Drop-off</mat-header-cell>
                    <mat-cell *matCellDef="let data; let i=index" class="fs-12 ">
                        <ng-container
                            *ngIf="data?.status.dev_name == 'received' || data?.status.dev_name == 'accepted_by_internal_user' || data?.status.dev_name == 'transferred_by_internal_user'">
                            <span class="mobile-label">Drop-off:</span>
                            <span class="fs-12 " *ngIf="data?.pods?.length">
                                {{data?.pods[0].name_display}}
                                <ng-container *ngIf="data?.pods?.length > 1">
                                    <span [matTooltip]="data?.pods | tooltipList" matTooltipClass="tooltip-list">
                                        + {{data?.pods?.length - 1}} more
                                    </span>
                                </ng-container>
                            </span>
                            <span class="fs-12 " *ngIf="data?.pods?.length == 0">
                                -
                            </span>
                        </ng-container>
                        <ng-container
                            *ngIf="!(data?.status.dev_name == 'received' || data?.status.dev_name == 'accepted_by_internal_user' || data?.status.dev_name == 'transferred_by_internal_user')">
                            <span class="mobile-label">Drop-off:</span>
                            <span class="fs-12 " *ngIf="data?.req_pods?.length">
                                {{data?.req_pods[0].name_display}}
                                <ng-container *ngIf="data?.req_pods?.length > 1">
                                    <span [matTooltip]="data?.req_pods | tooltipList" matTooltipClass="tooltip-list">
                                        + {{data?.req_pods?.length - 1}} more
                                    </span>
                                </ng-container>
                            </span>
                            <span class="fs-12 " *ngIf="data?.req_pods?.length == 0">
                                -
                            </span>
                        </ng-container>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'equipment'">
                    <mat-header-cell *matHeaderCellDef> Equipment</mat-header-cell>
                    <mat-cell *matCellDef="let data; let i=index" class="fs-12 ">
                        <span class="mobile-label">Equipment:</span>
                        <span class="fs-12 " *ngIf="data?.requirement?.length">
                            {{data?.requirement[0].quantity}}*{{data?.requirement[0].container_size_type?.display}}
                            ({{data?.requirement[0].condition?.value}})
                            <ng-container *ngIf="data?.requirement?.length > 1">
                                <span [matTooltip]="data?.requirement | tooltipList" matTooltipClass="tooltip-list">
                                    + {{data?.requirement?.length - 1}} more
                                </span>
                            </ng-container>
                        </span>
                        <span class="fs-12 " *ngIf="data?.requirement?.length == 0">
                            -
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'requestor'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Requestor</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span class="mobile-label">Requestor:</span>
                        <span>
                            <ng-container *ngIf="!isCustomer">
                                {{data?.company ? data?.company : '-'}}
                                <br>
                                ({{data?.requestor}})
                                <span class="new" *ngIf="data?.company_is_virgin">New</span>
                            </ng-container>
                            <ng-container *ngIf="isCustomer">
                                {{data?.requestor}}
                            </ng-container>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'external_reference_no'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Ex. Ref No</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span class="mobile-label">Ex. Ref No:</span>
                        <div>
                            <div>
                                {{data?.external_reference_no == null ? "NA" : data?.external_reference_no}}
                            </div>
                            <!-- <div style="font-size: 10px; font-weight: bold;">
                                {{data?.request_source != null ? ' (' + data?.request_source + ')' : 'NA'}}
                            </div> -->
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'request_date'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Request Date</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span class="mobile-label">Request Date:</span>
                        <span>
                            {{data?.created_by}}
                            <br>
                            {{data?.request_date == null ? "-" : data?.request_date | date:"dd MMM, yyyy"}}
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container [matColumnDef]="'request_source'">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Request Source</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 ">
                        <span class="mobile-label">Request Source:</span>
                        <span>{{data.request_source}}</span>
                    </mat-cell>
                </ng-container>

                <ng-container [matColumnDef]="'status'">
                    <mat-header-cell *matHeaderCellDef> Status</mat-header-cell>
                    <mat-cell *matCellDef="let data" class="fs-12 " (click)="view(data)">
                        <span class="mobile-label">Status:</span>
                        <mat-chip [style.background-color]="data?.status?.color" style="color:white">
                            {{data?.status?.short_name == null ? "-" : data?.status?.short_name}}
                        </mat-chip>
                    </mat-cell>
                </ng-container>

                <mat-header-row class="header-row" *matHeaderRowDef="displayColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayColumns;" [class.blur]="update"></mat-row>
            </mat-table>
            <div class="loadingData" [class.d-none]="!update">
                <logzy-gear-loader></logzy-gear-loader>

            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25]" aria-label="Select page of users" [pageSize]="10"
                [length]="pageLength" (page)="pageChanged($event)" #paginator></mat-paginator>
            <!-- </ng-container> -->

            <ng-container *ngIf="!requestList?.data?.length">
                <div class="noData" (mousemove)="onMouseMove($event)">
                    <h1 #title>No Data Found</h1>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!requestList?.data?.length">
            <logzy-billu part1="No " part2="Request " part3="here." font="14px"></logzy-billu>
        </ng-container>
    </div>

</div>
